import React from 'react';
import {
    InputCheckbox,
    Text
} from '@knockrentals/knock-shared-web';
import { ServiceStatusLabel } from './TableColumns/ServiceStatusLabel';
import { ServiceStatusSwitch } from './TableColumns/ServiceStatusSwitch';
import { PROPERTY_LABEL } from './constants';

export function getTableColumns({
  filteredProperties,
  handleSettingsUpdate,
  isInternalMode,
  selectedProduct,
  selectedProperties,
  setSelectedProperties,
}) {
  const isAllChecked =
    !!filteredProperties.length && selectedProperties.length === filteredProperties.length;
  const isIndeterminate =
    selectedProperties.length > 0 &&
    selectedProperties.length < filteredProperties.length;

  const handleSelectPropertyOnChange = (e) => {
    const { checked: isSelected, name: propertyIdRaw } = e.target;
    const propertyId = Number(propertyIdRaw);

    setSelectedProperties((prevSelectedPropertyIds) =>
      isSelected
        ? prevSelectedPropertyIds.includes(propertyId)
          ? prevSelectedPropertyIds
          : [...prevSelectedPropertyIds, propertyId]
        : prevSelectedPropertyIds.filter((id) => id !== propertyId),
    );
  };

  const handleSelectAllOnChange = (e) => {
    const { checked: isSelected } = e.target;
    const nextSelectedPropertyIds = isSelected
      ? filteredProperties.map(({ propertyId }) => propertyId)
      : [];
    setSelectedProperties(nextSelectedPropertyIds);
  };

  return [
    {
      align: 'left',
      field: 'propertyId',
      width: '50px',
      headerStyle: { backgroundColor: '#FAFAFA' },
      title: isInternalMode ? (
        <InputCheckbox
          checked={isAllChecked}
          color="primary"
          indeterminate={isIndeterminate}
          label={<Text color="textPrimary" variant="subtitle2">
                   {PROPERTY_LABEL}
                 </Text>}
          onChange={handleSelectAllOnChange}
        />
      ) : (
        <Text color="textPrimary" variant="subtitle2">
          {PROPERTY_LABEL}
        </Text>
      ),
      render: (rowData) => {
        const { propertyId, propertyName } = rowData || {};
        return isInternalMode ? (
          <InputCheckbox
            checked={selectedProperties.includes(propertyId)}
            color="primary"
            label={<Text variant="body2">
              {propertyName}
            </Text>}
            name={propertyId}
            onChange={handleSelectPropertyOnChange}
          />
        ) : (
          <Text variant="body2">
            {propertyName}
          </Text>
        );
      },
      isAllChecked,
      isIndeterminate,
      selectedProperties,
    },
    {
      align: 'right',
      cellStyle: { paddingRight: '100px' },
      headerStyle: { paddingRight: '100px', backgroundColor: '#FAFAFA' },
      title: <ServiceStatusLabel />,
      width: '250px',
      render: (rowData) => {
        const { propertyId } = rowData;
        const isChecked = !!rowData[`${selectedProduct}Enabled`];
        const handleServiceStatusOnChange = (e) => {
          handleSettingsUpdate(propertyId, e.target.checked);
        };
        return (
          <ServiceStatusSwitch
            disabled={!isInternalMode}
            handleOnChange={handleServiceStatusOnChange}
            isChecked={isChecked}
            isInternalMode={isInternalMode}
          />
        );
      },
    },
  ];
}
